<script setup lang="ts">
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import AiMemoryPage from '@/components/AiWorkspace/Memory/AiMemoryPage.vue'

setPageTitle('Assistant memory')

// The AI workspace's layout and access subject; the chat's keyboard shortcuts do not apply here.
definePage({
  meta: {
    subject: PageMeta.AiWorkspace.Chat.Meta.subject,
    layout: PageMeta.AiWorkspace.Chat.Meta.layout,
  },
})
</script>

<template>
  <AiMemoryPage />
</template>
